import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { execute, reset } from './actions';
import { InferenceResultSubdiv } from '../../../models/InferenceResultSubdiv';
import { InferenceAdditionalResult } from '../../../models/InferenceAdditionalResult';
import { KansatsuKirokuObsrec } from '../../../models/KansatsuKirokuObsrec';

export interface InferenceResultSubdivState {
  loaded: boolean;
  results: InferenceResultSubdiv[];
  additionalResult: InferenceAdditionalResult;
  coordinatesResults: KansatsuKirokuObsrec['observationsScores'];
  croppedImage: {
    bucket: string;
    key: string;
  }
}

const initialState: InferenceResultSubdivState = {
  loaded: false,
  results: [],
  additionalResult: new InferenceAdditionalResult(),
  coordinatesResults: [],
  croppedImage: {
    bucket: '',
    key: ''
  }
};

const reducer = reducerWithInitialState(initialState)
  .case(execute.started, (state) => {
    return { ...state, loaded: false, result: {} };
  })
  .case(execute.done, (state, param) => {
    return {
      ...state,
      loaded: true,
      results: param.result.results,
      additionalResult: param.result.additionalResult,
      coordinatesResults: param.result.coordinatesResults,
      croppedImage: param.result.croppedImage
    };
  })
  .case(execute.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })

  .case(reset, (state) => {
    return { ...initialState };
  })
;

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/inferenceSubdiv/reducers.ts